import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "57",
  height: "57",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M19.696 30.039 45.403 4.337a5.134 5.134 0 0 1 7.26 7.26L26.958 37.297m-7.26-7.26 7.26 7.26m-7.26-7.26-3.18 10.44 10.44-3.18M42.836 6.905l7.26 7.26M9.673 43.9H7.968a5.135 5.135 0 0 0-3.63 8.763 5.14 5.14 0 0 0 3.63 1.504h35.938"
    }, null, -1)
  ])))
}
export default { render: render }